import APIService from "../../services/APIService";

import store from "@/store/";

export const namespaced = true;

export const state = {
  history: [],
  loading: false,
};

export const mutations = {
  ADD_CHANGE(state, change) {
    state.history.push(change);
  },
  UNDO_CHANGE(state, undoObject) {
    state.loading = true;
    if (undoObject.item.type === "bulk") {
      let changedGroups = [...undoObject.item.groups];
      changedGroups.forEach((group) => {
        group.status = undoObject.item.oldStatus;
      });

      changedGroups.unshift({ status: "undo" });
      APIService.updateDomains(changedGroups)

        .then((res) => {
          const notification = {
            type: undoObject.item.oldStatus,
            message: `${undoObject.item.groups.length} domains set to <i>${undoObject.item.oldStatus}</i>`,
          };
          console.log(res);
          //notificationService.mutations.PUSH(notification);
          state.loading = false;
          store.dispatch("notification/add", notification, { root: true });
        })
        .catch((error) => {
          const notification = {
            type: "error",
            message: "Bulk Update Error",
          };
          store.dispatch("notification/add", notification, { root: true });
          state.loading = false;
          console.log(error);
        });
    } else if (undoObject.item.type === "assignee") {
      //need ITEM and ASSIGNEE ID
      let newUserName;
      let assignee_id;
      let groupItem = undoObject.item.groupItem;
      if (undoObject.item.oldStatus != null) {
        assignee_id = undoObject.item.oldStatus.id;
        newUserName = undoObject.item.oldStatus.id;
      } else {
        assignee_id = null;
        newUserName = "UNASSIGNED";
      }

      console.log(groupItem);

      //groupItem.undo = true;

      APIService.updateGroupUser(groupItem, assignee_id).then((res) => {
        console.log(res);

        const notification = {
          type: "assigned",
          message: `${groupItem.group} assigned to ${newUserName}`,
        };
        state.loading = false;
        store.dispatch("notification/add", notification, { root: true });
      });
    } else if (undoObject.item.type === "single-link") {
      let linkItem = undoObject.item.link;

      linkItem.disavow_status = undoObject.item.oldStatus;

      console.log(linkItem);

      APIService.updateLink(linkItem).then((response) => {
        let response_data = JSON.parse(response.config.data);
        console.log(response_data);
        const notification = {
          type: response_data.disavow_status,
          message: `Link Status set to <i>${response_data.disavow_status}</i>:`,
          details: response_data.url,
        };
        state.loading = false;
        store.dispatch("notification/add", notification, { root: true });
      });
    } else if (undoObject.item.type === "bulk-link") {
      console.log(undoObject);
      let theLinks = undoObject.item.links;
      console.log(theLinks);
      theLinks.forEach((link) => {
        link.disavow_status = undoObject.item.oldStatus;
      });

      console.log(theLinks);
      APIService.updateLinks(theLinks).then((res) => {
        const notification = {
          type: undoObject.item.oldStatus,
          message: `${undoObject.item.links.length} Links Status set to <i>${undoObject.item.oldStatus}</i>:`,
          details: "",
        };
        console.log(res);
        state.loading = false;
        store.dispatch("notification/add", notification, { root: true });
      });
    } else if (undoObject.item.type === "bulk-assign") {
      APIService.updateDomains(undoObject.item.oldGroups).then((res) => {
        console.log(res);
        let notifcationMessage;
        if (undoObject.item.oldGroups.assignee_id) {
          notifcationMessage = `${undoObject.item.oldGroups.length} group(s) assigned to ${undoObject.item.oldGroups.assignee_id}`;
        } else {
          notifcationMessage = `${undoObject.item.oldGroups.length} group(s) set to UNASSIGNED`;
        }
        const notification = {
          type: "assigned",
          message: notifcationMessage,
        };
        console.log(res);
        state.loading = false;
        store.dispatch("notification/add", notification, { root: true });
      });
    } else {
      let theGroup = undoObject.item.group;
      console.log(theGroup);

      delete theGroup.num_links;
      delete theGroup.color;

      APIService.setDisavowStatus(
        theGroup,
        theGroup.id,
        "single",
        undoObject.item.oldStatus
      ).then((res) => {
        const notification = {
          type: undoObject.item.oldStatus,
          message: `Group Status set to <i>${undoObject.item.oldStatus}</i>:`,
          details: theGroup.group,
        };
        store.dispatch("notification/add", notification, { root: true });

        console.log(res);
        state.loading = false;
        //notificationService.mutations.PUSH(notification);
      });

      console.log(undoObject);
    }

    state.history.splice(undoObject.index, 1);

    let userInfo = store.getters["user/userInfo"];
    let currentUrl = store.getters["project/currentUrl"];
    let currentSortAndDir = store.getters["project/currentSortAndDir"];
    let currentSort = "ID";
    let currentDir = "asc";

    let disavowStatus;

    if (currentUrl.params.status === "allNew" || currentUrl === "myNew") {
      disavowStatus = "unassigned";
    } else {
      disavowStatus = currentUrl.params.status;
    }

    console.log;

    console.log(currentSortAndDir);
    if (currentSortAndDir) {
      currentSort = currentSortAndDir.order;
      currentDir = currentSortAndDir.direction;
    }

    console.log(currentUrl);
    let getConfig = {
      after_id: null,

      before_id: null,
      disavow_status: disavowStatus,
      limit: 25,
      orderBy: currentSort,
      orderDir: currentDir,
      project_id: currentUrl.params.id,
      assigned: true,
    };
    if (userInfo.admin === false) {
      getConfig.assignee_id = userInfo.user;
    }

    if (store.getters["project/currentUrl"].status === "allNew") {
      getConfig.assigned = false;
    }

    if (store.getters["project/currentUrl"].params.status === "myNew") {
      getConfig.disavow_status = "unassigned";
    }

    console.log(store.getters["project/currentUrl"]);

    console.log(getConfig);

    getConfig.sessionHistory = true;

    setTimeout(() => {
      store.dispatch(
        "project/fetchGroups",
        { config: getConfig },
        { root: true }
      );
    }, 500);
  },
};

export const actions = {
  addChange({ commit }, payload) {
    //when dispatching you must pass an object with action and groups properties
    //(commit);

    if (payload.type === "single") {
      handleSingleChange(commit, payload);
    } else if (payload.type === "bulk") {
      handleBulkChange(commit, payload);
    } else if (payload.type === "assignee") {
      handleAssigneeChange(commit, payload);
    } else if (payload.type === "single-link") {
      handleSingleLink(commit, payload);
    } else if (payload.type === "bulk-link") {
      handleBulkLink(commit, payload);
    } else if (payload.type === "bulk-assign") {
      handleBulkAssign(commit, payload);
    }
  },

  undoChange({ commit }, item) {
    // (indexOfChange);
    item.item.type;
    console.log(item);
    commit("UNDO_CHANGE", item);
  },
};

export const getters = {
  history: (state) => state.history,
  loading: (state) => state.loading,
};

function handleBulkAssign(commit, payload) {
  let oldGroups = [...payload.oldGroups];
  let newGroups = [...payload.newGroups];
  console.log(oldGroups);
  console.log(newGroups);

  let historyObject = {
    oldGroups: oldGroups,
    newGroups: newGroups,
    project_id: payload.project_id,
    newAssignee: payload.newAssignee,
    type: "bulk-assign",
  };
  commit("ADD_CHANGE", historyObject);
}

function handleSingleChange(commit, payload) {
  let oldGroup = { ...payload.item };

  oldGroup;

  let newGroup = { ...oldGroup };
  newGroup.status = payload.status;

  let historyObject = {
    newStatus: payload.status,
    oldStatus: oldGroup.status,
    group: newGroup,
    type: payload.type,
    project_id: payload.project_id,
  };

  commit("ADD_CHANGE", historyObject);
}

function handleBulkLink(commit, payload) {
  let selectedLinks = [...payload.links];

  let historyObject = {
    links: selectedLinks,
    oldStatus: payload.oldStatus,
    newStatus: payload.newStatus,
    project_id: payload.project_id,
    urls: payload.urls,
    type: "bulk-link",
  };

  commit("ADD_CHANGE", historyObject);
}

function handleSingleLink(commit, payload) {
  let oldLink = { ...payload.link };

  let newLink = { ...oldLink };
  newLink.status = payload.status;

  let historyObject = {
    newStatus: payload.newStatus,
    oldStatus: payload.oldStatus,
    link: newLink,
    type: payload.type,
    project_id: payload.project_id,
  };

  commit("ADD_CHANGE", historyObject);
}
//Remember to make documentation and code changes for code review
function handleBulkChange(commit, payload) {
  let selectedLinks = [...payload.selectedLinks];

  let historyObject = {
    groups: selectedLinks,
    oldStatus: payload.oldStatus,
    newStatus: payload.newStatus,
    project_id: payload.project_id,
    type: "bulk",
  };

  commit("ADD_CHANGE", historyObject);

  payload;
}

function handleAssigneeChange(commit, payload) {
  let historyObject = {
    groupItem: payload.groupItem,
    oldStatus: payload.oldStatus,
    newStatus: payload.newStatus,
    project_id: payload.project_id,
    type: "assignee",
  };

  commit("ADD_CHANGE", historyObject);
}
